import { render } from "./PersonasLabelsListModal.vue?vue&type=template&id=6d6f6571&scoped=true"
import script from "./PersonasLabelsListModal.vue?vue&type=script&lang=js"
export * from "./PersonasLabelsListModal.vue?vue&type=script&lang=js"

import "./PersonasLabelsListModal.vue?vue&type=style&index=0&id=6d6f6571&lang=scss&scoped=true"
import "./PersonasLabelsListModal.vue?vue&type=style&index=1&id=6d6f6571&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d6f6571"]])

export default __exports__